import React, { Component } from 'react'
import { withRouter, NavLink, Link } from 'react-router-dom';
import authStore from '../../../stores/auth-store';
import loadsStore from '../../../stores/loads-store';

class LinkMenu extends Component {
    handleLogout = () => {
        localStorage.clear();
        clearInterval(loadsStore.scrollTimer)
        clearInterval(loadsStore.scrollTimer1)
        authStore.logout();
        this.props.history.push('/login')
    }
    render() {
        let role = localStorage.getItem('role')

        return (
            <ul className="link-menu">
                <li>
                    <Link activeClassName="activeLink" style={{ textDecoration: "none" }} to="/">Home</Link>
                </li>
                <li>
                    {role === 'jumper' ?
                        <Link style={{ textDecoration: "none" }} to="/daily-activity">
                            Daily Activity
                            </Link>
                        : null
                    }
                </li>
                <li>
                    <Link style={{ textDecoration: "none" }} to="/loadcall">
                        Load Call
                        </Link>
                </li>
                <li>
                    <Link style={{textDecoration: "none"}} to="/staffboard">
                        Staff Board
                    </Link>
                </li>
                <li style={{ fontWeight: 600, fontSize: "1.2rem", cursor: "pointer" }}>
                    <Link style={{ textDecoration: "none" }}  to="#" >
                        <span onClick={this.handleLogout}>
                            Logout <i className="fa fa-sign-out" />
                        </span>
                    </Link>

                </li>
            </ul>
        )
    }
}
export default withRouter(LinkMenu)
